import { createActions, createReducer } from 'reduxsauce'

import ItensDetalhamentoLancamentoService from '../../servicos/ItensDetalhamentoLancamentoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItensDetalhamentoLancamentoInicio: [],
    buscaItensDetalhamentoLancamentoSucesso: ['itensDetalhamentoLancamento'],
    buscaItensDetalhamentoLancamentoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaItensDetalhamentoLancamento = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItensDetalhamentoLancamentoInicio())
        let serv = new ItensDetalhamentoLancamentoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaItensDetalhamentoLancamentoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItensDetalhamentoLancamentoErro(error)))
    }
}

const buscaItensDetalhamentoLancamentoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaItensDetalhamentoLancamentoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaItensDetalhamentoLancamentoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itensDetalhamentoLancamento, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITENS_DETALHAMENTO_LANCAMENTO_INICIO]: buscaItensDetalhamentoLancamentoInicio,
    [Types.BUSCA_ITENS_DETALHAMENTO_LANCAMENTO_ERRO]: buscaItensDetalhamentoLancamentoErro,
    [Types.BUSCA_ITENS_DETALHAMENTO_LANCAMENTO_SUCESSO]: buscaItensDetalhamentoLancamentoSucesso,
})
